import { useMemo } from "react"

import { Button } from "@/3514/components"
import { type IAppState, useAppSelector } from "@/3514/store/app"
import { Role } from "@/constants"
import { useSimulabContext } from "@/entities/simulab"

import "../styles.scss"

type Props = {
    onClickFeedback: () => void
}

export const SimulabFeedbackMobile = ({ onClickFeedback }: Props) => {
    const { simulabMessages, selectedMessage } = useSimulabContext()
    const { isOpenBurgerMenu }: IAppState = useAppSelector()

    const currentFeedback = useMemo(() => {
        const message = simulabMessages?.messages?.find(message => message?.id === selectedMessage)?.owlFeedback

        if (!message && !selectedMessage) {
            const recentMessage = simulabMessages?.messages
                ?.slice(-3)
                .find(message => message.authorRole === Role.Participant)
            return recentMessage?.owlFeedback
        }

        return message
    }, [simulabMessages, selectedMessage])

    return (
        !isOpenBurgerMenu &&
        simulabMessages?.messages?.length > 0 && (
            <Button className="p-0 simulab-feedback-mobile" isContainer onClick={onClickFeedback}>
                <div className="simulab-feedback-mobile__body">
                    <p className="m-0 fs-14">{currentFeedback?.feedbackData?.feedbackSummary ?? ""}</p>
                </div>
            </Button>
        )
    )
}
